/**
 * Resolves the active search experience based on the customer's feature keys.
 * The hybrid search page only supports free-text `q` queries, so only plain
 * text/ATC-code searches should be routed here.
 */
export default function useSearchRoute() {
  const userStore = useUserStore()

  const searchRouteName = computed(() => userStore.hasHybridSearchFeature ? 'hybrid-search' : 'search')

  return {
    searchRouteName,
  }
}
